import React, { createContext, useContext, useEffect, useState } from "react";
import { http } from "@/lib/api";

const FilterCtx = createContext(null);

export const FilterProvider = ({ children }) => {
  const [filters, setFilters] = useState({
    dateMode: "preset", // "preset" | "custom"
    days: 90,
    startDate: null, // ISO yyyy-mm-dd
    endDate: null,
    location: "all",
    carrier: "all",
    mode: "all",
  });
  const [meta, setMeta] = useState({ locations: [], carriers: [], modes: [] });
  const [dataStatus, setDataStatus] = useState({ count: 0, is_demo: true });

  useEffect(() => {
    http.get("/meta").then((r) => setMeta(r.data)).catch(() => {});
    refreshStatus();
  }, []);

  const refreshStatus = () =>
    http.get("/dashboard/data-status").then((r) => setDataStatus(r.data)).catch(() => {});

  const setFilter = (key, value) => setFilters((f) => ({ ...f, [key]: value }));

  const setDatePreset = (days) =>
    setFilters((f) => ({ ...f, dateMode: "preset", days, startDate: null, endDate: null }));

  const setDateRange = (start, end) =>
    setFilters((f) => ({ ...f, dateMode: "custom", startDate: start, endDate: end }));

  const queryParams = () => {
    const q = {};
    if (filters.dateMode === "custom" && filters.startDate && filters.endDate) {
      q.start_date = filters.startDate;
      q.end_date = filters.endDate;
    } else {
      q.days = filters.days;
    }
    if (filters.location !== "all") q.location = filters.location;
    if (filters.carrier !== "all") q.carrier = filters.carrier;
    if (filters.mode !== "all") q.mode = filters.mode;
    return q;
  };

  return (
    <FilterCtx.Provider value={{ filters, setFilter, setDatePreset, setDateRange, meta, queryParams, dataStatus, refreshStatus }}>
      {children}
    </FilterCtx.Provider>
  );
};

export const useFilters = () => useContext(FilterCtx);
